const processableStatuses = new Set(['merging', 'planning', 'ready', 'running']);
const retryableStatuses = new Set([408, 409, 425, 429]);

export function shouldDriveBatchImageJob(status: string) {
  return processableStatuses.has(status);
}

export function isRetryableBatchImageRequest(status?: number) {
  return !status || status >= 500 || retryableStatuses.has(status);
}
